"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cover_template_data_1 = require("./cover-template-data");
var DataForMerging = /** @class */ (function () {
    function DataForMerging() {
        this.isEditSelectionButtonVisible = true;
        this.documentsToMerge = [];
        this.coverTemplateData = new cover_template_data_1.CoverTemplateData();
    }
    return DataForMerging;
}());
exports.DataForMerging = DataForMerging;
//# sourceMappingURL=data-for-merging.js.map